import http, { url } from '../../../http'

class ActAPI {

  async save(CompanyID, ActID, Act) {
    const response = await http(`saveActforCompany`, 'POST', {
      companies_id: CompanyID,
      typeact_id: ActID,
      file: Act
    })
    return response || null
  }

  async get(CompanyID, page) {
    const response = await http(`allactforcompany/${CompanyID}?page=${page}`, 'GET')
    return response || null
  }

  async getTypes() {
    const response = await http(`type_act`, 'GET')
    return response.Type_act.data || null
  }
  
  actaDesignacion() {
    return url(`acta-designacion`)
  }

  actaConvocatoria() {
    return url(`actadeconvocatoria`)
  }

  actaApertura() {
    return url(`actaapertura`)
  }

  formularioInscripcion() {
    return url(`forminscription`)
  }

  registroVotantes() {
    return url(`registvotantes`)
  }

  informeTrimestral() {
    return url(`informTrimestral`)
  }

}

export default new ActAPI()